import React from "react";
import PropTypes from "prop-types";
import { Pagination } from "@opendate-app/setlist";
import "./classesShared.css";

const ClassesTableFooter = ({ rangeStart, rangeEnd, total, noun, page, totalPages, onPageChange }) => (
  <div className="classes-table-footer px-4 py-3">
    <span className="classes-text-secondary small" role="status">{`Showing ${rangeStart}–${rangeEnd} of ${total} ${noun}`}</span>
    <Pagination
      align="right"
      currentPage={page}
      totalPages={totalPages}
      onPageChange={onPageChange}
    />
  </div>
);

ClassesTableFooter.propTypes = {
  rangeStart: PropTypes.number.isRequired,
  rangeEnd: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  noun: PropTypes.string.isRequired,
  page: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default ClassesTableFooter;
